import Component from './component';

export interface Props {
	routes: Route[];
	isSponsored?: boolean;
	sponsoredCopy?: string;
}

interface Route {
	name: string;
	path: string;
}

Component.defaultProps = {
    isSponsored: false,
};
export default Component;
